/**
 * @returns {Immutable.Map}
 */
export function getSecureTradingDetails(state) {
  return state.getIn(["school_money", "secureTrading"]);
}

/**
 * Get secure trading status on API response.
 */
export function getSecureTradingStatus(state) {
  return getSecureTradingDetails(state).status;
}

/**
 * Get secure trading error message on API response.
 */
export function getSecureTradingMessage(state) {
  return getSecureTradingDetails(state).message;
}

/**
 * Get secure trading error code on API response.
 */
export function getSecureTradingCode(state) {
  return getSecureTradingDetails(state).code;
}

/**
 * Get secure trading threeDS on API response.
 */
export function getSecureTradingThreeDS(state) {
  let threeds = {};
  threeds.status   = getSecureTradingDetails(state).threeds_status;
  threeds.enrolled = getSecureTradingDetails(state).threeds_enrolled;
  threeds.acsurl   = getSecureTradingDetails(state).threeds_acsurl;
  threeds.pareq    = getSecureTradingDetails(state).threeds_pareq;
  threeds.termurl  = getSecureTradingDetails(state).threeds_termurl;
  threeds.md       = getSecureTradingDetails(state).threeds_md;
  return threeds;
}

/**
 * Get cardholder name for psd2 payment
 */
export function getSecureTradingCardHolderName(state){
  return getSecureTradingDetails(state).card_holder_name;
}


/**
 * Get secure trading jwt string
 */
 export function getSecureTradingCardPayJWTString(state){
   return getSecureTradingDetails(state).payment_request_jwt_string;
 }

export function getSecureTradingPSD2ErrorCode(state){
  return getSecureTradingDetails(state).error_code;
}

export function getSecureTradingPSD2ErrorMessage(state){
  return getSecureTradingDetails(state).error_message;
}

export function getSecureTradingPSD2ProcessedJWT(state){
  return getSecureTradingDetails(state).payment_response_jwt_string;
}

export function getSecureTradingWalletPayJWTString(state){
  return getSecureTradingDetails(state).wallet_pay_jwt_string;
}



// WEBPACK FOOTER //
// ./src/state/school_money/selectors/secure_trading.js